import { BottomMenuContainer } from "./bottom-menu-container";

// Exported as default for dynamic import
export default BottomMenuContainer;
